import { render, staticRenderFns } from "./maillog-config.vue?vue&type=template&id=e5ed6652&"
import script from "./maillog-config.vue?vue&type=script&lang=js&"
export * from "./maillog-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports